package ru.villawonka.app.presentation.screens.search.model

import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.presentation.screens.search.compose.view.TabBadge
import ru.villawonka.app.presentation.screens.search.compose.view.TabItem
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.category_exchange
import villawonka.composeapp.generated.resources.category_housing
import villawonka.composeapp.generated.resources.category_transport
import villawonka.composeapp.generated.resources.category_visa

sealed interface SearchCategoryUIModel {

    val tabItem: TabItem

    data object Accommodation : SearchCategoryUIModel {

        override val tabItem: TabItem
            get() = TabItem(
                id = 0,
                title = AppResources.strings.tabBarItemProperty,
                image = Res.drawable.category_housing,
            )
    }

    data object Transport : SearchCategoryUIModel {

        override val tabItem: TabItem
            get() = TabItem(
                id = 1,
                title = AppResources.strings.tabBarItemTransport,
                image = Res.drawable.category_transport,
                badge = TabBadge(
                    text = AppResources.strings.tabBarSoonBadge
                ),
                enabled = false,
            )
    }


    data object MoneyExchange : SearchCategoryUIModel {

        override val tabItem: TabItem
            get() = TabItem(
                id = 2,
                title = AppResources.strings.tabBarItemMoneyExchange,
                image = Res.drawable.category_exchange,
                badge = TabBadge(
                    text = AppResources.strings.tabBarSoonBadge
                ),
                enabled = false,
            )
    }


    data object VisaAgency : SearchCategoryUIModel {

        override val tabItem: TabItem
            get() = TabItem(
                id = 3,
                title = AppResources.strings.tabBarItemVisaAgency,
                image = Res.drawable.category_visa,
                badge = TabBadge(
                    text = AppResources.strings.tabBarSoonBadge
                ),
                enabled = false,
            )
    }



}

fun PostTypeDomain.toUIModel() = when (this) {
    PostTypeDomain.ACCOMMODATION -> SearchCategoryUIModel.Accommodation
    PostTypeDomain.TRANSPORT -> SearchCategoryUIModel.Transport
    PostTypeDomain.MONEY_EXCHANGE -> SearchCategoryUIModel.MoneyExchange
    PostTypeDomain.VISA_AGENCY -> SearchCategoryUIModel.VisaAgency
}

fun SearchCategoryUIModel.toDomain() = when (this) {
    is SearchCategoryUIModel.Accommodation -> PostTypeDomain.ACCOMMODATION
    is SearchCategoryUIModel.Transport -> PostTypeDomain.TRANSPORT
    is SearchCategoryUIModel.MoneyExchange -> PostTypeDomain.MONEY_EXCHANGE
    is SearchCategoryUIModel.VisaAgency -> PostTypeDomain.VISA_AGENCY
}